import React, { FC, useEffect, useState } from "react";
import { DEF_PG_SIZE_FILTER } from "../../constants/maximum-page-size";
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import ButtonConfigurationColumns from "../../models/ColumnDefinitions/ButtonConfigurationColumns";
import { ListData } from "../../models/ListData";
import { ListQuery } from "../../models/ListQuery";
import { getIdemiaButtonConfigurationForTimeAttendance } from "../../services/biometricPresetService";
import TableTab from "../tabs/table-tab";
import ButtonConfigModal from "./ButtonConfigWizard/ButtonConfigModal";
import ActivityFrame from "../activity-frame/activity-frame";
import ButtonConfigurationSearch from "../../models/search/ButtonConfigurationSearch";

interface Props {
    presetId: string,    
}

const ButtonConfiguration: FC<Props> = ({ presetId }) => {
    const { translate } = useLocale();
    const [openModal, setOpenModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>(undefined);
    const [busy, setBusy] = useState(false);

    const [dataRefresh, setDataRefresh] = useState(() => (dataMethod?: (query?: ListQuery) => Promise<ListData>) => { return });
    const manualDataRefresh = (refreshData: (dataMethod?: (query?: ListQuery) => Promise<ListData>) => void) => {
        setDataRefresh(() => refreshData);
    }

    useEffect(() => {        
        dataRefresh((query) => getIdemiaButtonConfigurationForTimeAttendance(presetId, query));
    }, [presetId])

    return <div className="mt-1">
        <ActivityFrame busy={busy} className='flex flex-col flex-grow bg-white'>
            <TableContextProvider
                dataMethod={(listParameters?: ListQuery) => getIdemiaButtonConfigurationForTimeAttendance(presetId, listParameters)}
                manualDataRefresh={manualDataRefresh}
                tableDescriptor={ButtonConfigurationColumns}
                searchDescriptor={ButtonConfigurationSearch}
                useTable
                usePagination
                useSearch
                useSort
                useFilter
                lookup={[]}
                maxPageSize={DEF_PG_SIZE_FILTER}
                editMethod={() => {}}
            >
                <TableTab
                    title={translate.byKey(TranslationKeys.buttonConfiguration)}
                    selectRows={false}
                    onRowClicked={(row) => {
                        setSelectedRow(row)
                        setOpenModal(true)
                    }}
                    cyName="buttonConfiguration"
                />
            </TableContextProvider>
        </ActivityFrame>
        <ButtonConfigModal
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
            rowData={selectedRow}
            setBusy={setBusy}
        />
    </div>
}

export default ButtonConfiguration;